export const ROLE_ADMIN = "admin";
export const ROLE_STANDARD = "standard";
export const ROLE_OWNER = "owner";

/*
 isOwner: role === 'admin'
 isRecruiter: role === 'standard'
 isAdmin: role === 'admin' && !isOwner
 */
